import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { ClaimBanner } from './ClaimBanner'
import { useMe } from '../lib/auth-client'
import {
  startCogoBasketWorker,
  stopCogoBasketWorker,
} from '../lib/cogoBasketWorker'
import {
  startCogoEnrichWorker,
  stopCogoEnrichWorker,
} from '../lib/cogoEnrichWorker'
import {
  startCogoProductviewIngestWorker,
  stopCogoProductviewIngestWorker,
} from '../lib/cogoProductviewIngestWorker'
import { startCogoSyncHudBridge } from '../lib/cogoSyncControl'

/** Session gate: welcome for guests, soft claim for anonymous, else app. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { data: me, isLoading, mutate } = useMe()

  useEffect(() => {
    void mutate()
  }, [location.pathname, mutate])

  useEffect(() => {
    if (!me?.user || me.user.tenantId == null) {
      stopCogoEnrichWorker()
      stopCogoBasketWorker()
      stopCogoProductviewIngestWorker()
      return
    }
    startCogoEnrichWorker()
    startCogoBasketWorker()
    startCogoProductviewIngestWorker()
    const stopHudBridge = startCogoSyncHudBridge()
    return () => {
      stopCogoEnrichWorker()
      stopCogoBasketWorker()
      stopCogoProductviewIngestWorker()
      stopHudBridge()
    }
  }, [me?.user?.id, me?.user?.tenantId])

  if (isLoading && !me) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Laden…
      </div>
    )
  }

  if (!me?.user) {
    return <Navigate to="/welcome" replace state={{ from: location }} />
  }

  if (me.user.tenantId == null) {
    return <Navigate to="/onboarding" replace />
  }

  return (
    <>
      {me.user.isAnonymous && <ClaimBanner me={me} />}
      {children}
    </>
  )
}
